import { render } from "./cancel-bet.vue?vue&type=template&id=41c822ff&scoped=true&ts=true"
import script from "./cancel-bet.vue?vue&type=script&lang=ts"
export * from "./cancel-bet.vue?vue&type=script&lang=ts"

import "./cancel-bet.vue?vue&type=style&index=0&id=41c822ff&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c822ff"]])

export default __exports__